import React from "react"
import ReduxProvider from "./src/store/Provider"

const Provider = ({ element }) => {
  return <ReduxProvider>
        {element}
  </ReduxProvider>
}

export default Provider